import React, { useEffect, useState } from 'react';
import { Card, CardBody, CardTitle, Collapse, Table } from 'reactstrap';
import _ from 'lodash';
import { MdOutlineExpandLess, MdOutlineExpandMore } from "react-icons/md";

export default function VendorPallet(props) {
   const ICONS = {
      collapseIcon: <MdOutlineExpandLess className="mobileToggle align-self-center" />,
      expandIcon: <MdOutlineExpandMore className="mobileToggle align-self-center" />
   }
   const [expanded, setExpanded] = useState(false);
   const [icon, setIcon] = useState(ICONS.collapseIcon);
   const [pallets, setData] = useState([]);

   useEffect(() => {
      if (pallets !== props.data) {
         setData(props.data)
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [props])

   function onClick() {
      // This is only so that the card is clickable and
      // can be used to toggle the accordian open/closed
      setExpanded(!expanded);
      if (expanded === true)
         setIcon(ICONS.expandIcon);
      else
         setIcon(ICONS.collapseIcon);
      props.onToggle();
   }

   return (
      <>
         {_.map(pallets, (item, index) => {
            return (
               <div details={item} key={index} >
                  <Card id="toggler" className="py-0" onClick={onClick} style={{ cursor: "pointer" }}>
                     <CardBody className={(index % 2 === 0) ? "mobileGrayBg text-black my-0 py-2 px-2" : "mobileGrayBgAlt text-black my-0 py-2 px-2"}>
                        <CardTitle className={(index % 2 === 0) ? "mobileGrayBg text-black my-0 py-0 px-0" : "mobileGrayBgAlt text-black my-0 py-2 px-2"}>
                           {icon} {item.barcode}
                        </CardTitle>

                        <Collapse className="text-black" toggler="#toggler" isOpen={expanded}>
                           <Table borderless size="sm">
                              <tbody>
                                 <tr>
                                    <td className="data-cell my-0 py-0" width="35px">&nbsp;</td>
                                    <td className="data-cell my-0 py-0">
                                       <label className="text-black h6 fw-bold my-0">Net Wt:</label>
                                       <label className="text-black h6 mx-1 my-0">{item.netWeight.toLocaleString("en-US", { maximumFractionDigits: 4 })}</label>
                                    </td>
                                 </tr>
                                 {item.poNum ?
                                    <tr>
                                       <td className="data-cell my-0 py-0">&nbsp;</td>
                                       <td className="data-cell my-0 py-0">
                                          <label className="text-black h6 fw-bold my-0">PO #:</label>
                                          <label className="text-black h6 mx-1 my-0">{item.poNum}</label>
                                       </td>
                                    </tr>
                                    : null
                                 }
                              </tbody>
                           </Table>
                        </Collapse>
                     </CardBody>
                  </Card>
               </div>
            )
         })}
      </>
   )
}
